var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasErrors)?_c('div',{staticClass:"flags mt-xs text--orange"},[_c('svg',[_c('use',{attrs:{"xlink:href":"#alert"}})]),_vm._v(" "),_c('div',[(_vm.maxWatts)?_c('p',{staticClass:"small semi"},[_vm._v("This system is in excess of 100kW and is no longer eligible for STCs. The system may be eligible for LGCs.")]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }